const initState = {
    isLoading: false,
    data: [],
    error: null,
  };
  
  const BankListReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_LOADING_BANK_LIST":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_BANK_LIST":
        return {
          ...state,
          isLoading: false,
          data: action.payload.data,
        };
      case "SET_ERROR_BANK_LIST":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default BankListReducer;